import React from 'react';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import fetchConfig from '../Constants/fetch';

// eslint-disable-next-line import/no-mutable-exports
let Board = [
    {
        id: 0,
        nameId: 'start-tile',
        type: 'start',
        checked: true,
        passed: false,
        landed: false,
    },
    {
        id: 1,
        type: 'planned-task',
        nameId: 'tile-1',
        checked: false,
        landed: false,
    },
    {
        id: 2,
        type: 'planned-task',
        nameId: 'tile-2',
        checked: false,
        landed: false,
    },
    {
        id: 3,
        type: 'planned-task',
        nameId: 'tile-3',
        checked: false,
        landed: false,
    },
    {
        id: 4,
        type: 'Risk',
        nameId: 'risk-tile-4',
        checked: false,
        landed: false,
    },
    {
        id: 5,
        type: 'unplanned-task',
        nameId: 'unplanned-task-tile-5',
        checked: false,
        landed: false,
    },
    {
        id: 6,
        type: 'mile-stone',
        nameId: 'mile-stone-1',
        checked: false,
        landed: false,
        milestone: {
            passed: false,
            popUp: false,
            id: 1,
            resources: {
                standard: 2,
                senior: 2,
                expensive: 0,
                budget: 1000,
            },
        },
    },
    {
        id: 7,
        type: 'planned-task',
        nameId: 'planned-task-tile-7',
        checked: false,
        landed: false,
    },
    {
        id: 8,
        type: 'planned-task',
        nameId: 'planned-task-tile-8',
        checked: false,
        landed: false,
    },
    {
        id: 9,
        type: 'Constraint',
        nameId: 'constraint-tile-9',
        checked: false,
        landed: false,
    },
    {
        id: 10,
        type: 'planned-task',
        nameId: 'planned-task-tile-10',
        checked: false,
        landed: false,
    },
    {
        id: 11,
        type: 'unplanned-task',
        checked: false,
        landed: false,
    },
    {
        id: 12,
        type: 'gate',
        checked: false,
        landed: false,
        gate: {
            passed: false,
            id: 1,
            resources: {
                standard: 3,
                senior: 2,
                expensive: 1,
                budget: 2000,
            },
            rates: {
                high: 10000,
                medium: 8000,
                low: 4000,
            },
        },
    },
    {
        id: 13,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 14,
        type: 'Risk',
        checked: false,
        landed: false,
    },
    {
        id: 15,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 16,
        nameId: 'nice-tile',
        type: 'Constraint',
        checked: false,
        landed: false,
    },
    {
        id: 17,
        type: 'unplanned-task',
        checked: false,
        landed: false,
    },
    {
        id: 18,
        type: 'mile-stone',
        checked: false,
        landed: false,
        milestone: {
            passed: false,
            popUp: false,
            id: 2,
            resources: {
                standard: 2,
                senior: 1,
                expensive: 0,
                budget: 1000,
            },
        },
    },
    {
        id: 19,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 20,
        type: 'unplanned-task',
        checked: false,
        landed: false,
    },
    {
        id: 21,
        type: 'Constraint',
        checked: false,
        landed: false,
    },
    {
        id: 22,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 23,
        type: 'Risk',
        checked: false,
        landed: false,
    },
    {
        id: 24,
        type: 'gate',
        checked: false,
        landed: false,
        gate: {
            id: 2,
            passed: false,
            resources: {
                standard: 3,
                senior: 3,
                expensive: 1,
                budget: 3000,
            },
            rates: {
                high: 18000,
                medium: 14000,
                low: 8000,
            },
        },
    },
    {
        id: 25,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 26,
        type: 'unplanned-task',
        checked: false,
        landed: false,
    },
    {
        id: 27,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 28,
        type: 'Constraint',
        checked: false,
        landed: false,
    },
    {
        id: 29,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 30,
        type: 'mile-stone',
        checked: false,
        landed: false,
        milestone: {
            passed: false,
            popUp: false,
            id: 3,
            resources: {
                standard: 3,
                senior: 1,
                expensive: 1,
                budget: 1000,
            },
        },
    },
    {
        id: 31,
        type: 'Risk',
        checked: false,
        landed: false,
    },
    {
        id: 32,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 33,
        type: 'Constraint',
        checked: false,
        landed: false,
    },
    {
        id: 34,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 35,
        type: 'unplanned-task',
        checked: false,
        landed: false,
    },
    {
        id: 36,
        type: 'gate',
        checked: false,
        landed: false,
        gate: {
            id: 3,
            passed: false,
            resources: {
                standard: 3,
                senior: 1,
                expensive: 1,
                budget: 2000,
            },
            rates: {
                high: 30000,
                medium: 20000,
                low: 16000,
            },
        },
    },
    {
        id: 37,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 38,
        type: 'Risk',
        checked: false,
        landed: false,
    },
    {
        id: 39,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 40,
        type: 'unplanned-task',
        checked: false,
        landed: false,
    },
    {
        id: 41,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 42,
        type: 'mile-stone',
        checked: false,
        landed: false,
        milestone: {
            passed: false,
            popUp: false,
            id: 4,
            resources: {
                standard: 2,
                senior: 2,
                expensive: 0,
                budget: 1000,
            },
        },
    },
    {
        id: 43,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 44,
        type: 'Constraint',
        checked: false,
        landed: false,
    },
    {
        id: 45,
        type: 'Risk',
        checked: false,
        landed: false,
    },
    {
        id: 46,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 47,
        type: 'unplanned-task',
        checked: false,
        landed: false,
    },
    {
        id: 48,
        type: 'gate',
        checked: false,
        landed: false,
        gate: {
            id: 4,
            passed: false,
            resources: {
                standard: 2,
                senior: 2,
                expensive: 0,
                budget: 1000,
            },
            rates: {
                high: 38000,
                medium: 32000,
                low: 28000,
            },
        },
    },
    {
        id: 49,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 50,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 51,
        type: 'Constraint',
        checked: false,
        landed: false,
    },
    {
        id: 52,
        type: 'unplanned-task',
        checked: false,
        landed: false,
    },
    {
        id: 53,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 54,
        type: 'mile-stone',
        checked: false,
        landed: false,
        milestone: {
            popUp: false,
            id: 5,
            passed: false,
            resources: {
                standard: 0,
                senior: 0,
                expensive: 0,
                budget: 500,
            },
        },
    },
    {
        id: 55,
        type: 'unplanned-task',
        checked: false,
        landed: false,
    },
    {
        id: 56,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 57,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 58,
        type: 'Constraint',
        checked: false,
        landed: false,
    },
    {
        id: 59,
        type: 'planned-task',
        checked: false,
        landed: false,
    },
    {
        id: 60,
        type: 'mile-stone',
        checked: false,
        landed: false,
        milestone: {
            popUp: false,
            id: 6,
            passed: false,
            resources: {
                standard: 0,
                senior: 0,
                expensive: 0,
                budget: 0,
            },
        },
    },
    {
        id: 61,
        type: 'finish',
        checked: false,
        landed: false,
    },
];
let flag = true;
const getBoardById = async boardId => {
    let result;
    try {
        result = await axios.get(`${fetchConfig.prefix}/game/get_board_by_id`, {
            params: {
                boardId,
            },
        });
        Board = result.data;
    } catch (e) {
        console.log(e);
    }
};
if (flag) {
    getBoardById(1);
    flag = false;
}
const updateBoard = async newBoard => {
    Board = newBoard;
    return Board;
};

export { Board, updateBoard };
